import React from 'react';
import { Link } from 'react-router-dom';

const SERVICES = [
  { icon: '🌐', title: 'Web Services', desc: 'Website design, development, hosting, e-commerce, CMS, and maintenance for all your digital needs.' },
  { icon: '🎨', title: 'Multimedia & Graphic Design', desc: 'Creative multimedia solutions and professional graphic design that elevates your brand identity.' },
  { icon: '📈', title: 'SEO & Digital Marketing', desc: 'Search engine optimization and internet marketing strategies to grow your online presence.' },
  { icon: '💻', title: 'Software Development', desc: 'Custom software, application design, database development, and data warehousing solutions.' },
  { icon: '🛠️', title: 'Technology Support', desc: 'Comprehensive IT support and technology consulting to keep your business running smoothly.' },
  { icon: '📋', title: 'Back Office Support', desc: 'Data processing, virtual assistant services, and back-office operations to streamline your workflow.' },
  { icon: '🏥', title: 'Medical Services', desc: 'Specialized IT and data solutions tailored for the healthcare and medical industry.' },
  { icon: '📱', title: 'Mobile App Development', desc: 'Native and cross-platform mobile applications designed for performance and user experience.' },
  { icon: '🎓', title: 'Training & Career Development', desc: 'Professional training programs and career development services to upskill your workforce.' },
];

const Services = () => (
  <>
    {/* Page Header */}
    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #002868, #1a56db)' }}>
      <div className="container py-4">
        <h1 className="fw-bold">Our Services</h1>
        <p className="lead" style={{ color: '#cbd5e1' }}>Comprehensive technology solutions for your business</p>
      </div>
    </section>

    {/* Intro */}
    <section className="py-5 bg-white">
      <div className="container py-3 text-center" style={{ maxWidth: 700 }}>
        <span className="badge px-3 py-2 mb-3" style={{ background: '#dbeafe', color: '#1a56db', fontSize: 13, fontWeight: 600, borderRadius: 40 }}>WHAT WE OFFER</span>
        <h2 className="fw-bold mb-3">Our Core Services</h2>
        <p className="text-muted" style={{ fontSize: 17 }}>
          Comprehensive end-to-end solutions designed to power businesses of all sizes across every sector.
        </p>
      </div>
    </section>

    {/* Services Grid */}
    <section className="py-5 bg-light">
      <div className="container py-4">
        <div className="row g-4">
          {SERVICES.map((s, i) => (
            <div key={i} className="col-12 col-sm-6 col-lg-4">
              <div
                className="card h-100 border p-3"
                style={{ borderColor: '#e2e8f0', borderRadius: 14, transition: 'all 0.25s ease', cursor: 'pointer' }}
                onMouseEnter={e => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 12px 30px rgba(26,86,219,0.12)';
                  e.currentTarget.style.borderColor = '#bfdbfe';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.borderColor = '#e2e8f0';
                }}
              >
                <div className="card-body">
                  <div style={{ fontSize: 40 }} className="mb-3">{s.icon}</div>
                  <h5 className="fw-bold mb-2" style={{ color: '#1e293b' }}>{s.title}</h5>
                  <p className="text-muted small" style={{ lineHeight: 1.6 }}>{s.desc}</p>
                  <Link to="/contact" className="fw-semibold text-decoration-none small" style={{ color: '#1a56db' }}>
                    Learn more →
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* CTA */}
    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #1a56db, #0ea5e9)' }}>
      <div className="container py-4">
        <h2 className="fw-bold mb-3">Ready to Get Started?</h2>
        <p className="lead mb-4">Let's discuss how we can help transform your business.</p>
        <Link to="/contact" className="btn btn-warning btn-lg fw-bold px-5">Contact Us →</Link>
      </div>
    </section>
  </>
);

export default Services;
